import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { playerNormal } from '@/state/playerPosition'
import { useMountStore } from '@/state/useMountStore'
import { getAllMobs } from './mobRegistry'
import { MobType } from './types'

/**
 * R3F component that periodically checks if a horse is near the player.
 * Sets useMountStore.nearHorse for the UI prompt.
 */
export function HorseMountDetector() {
  const timerRef = useRef(0)

  useFrame((_, delta) => {
    timerRef.current += delta
    if (timerRef.current < 0.2) return  // check at 5Hz
    timerRef.current = 0

    if (useMountStore.getState().mounted) {
      useMountStore.getState().setNearHorse(false)
      return
    }

    const allMobs = getAllMobs()
    const pn = playerNormal
    let found = false

    for (const mob of allMobs) {
      if (mob.type !== MobType.Horse || mob.mounted) continue
      const dot = mob.nx * pn.x + mob.ny * pn.y + mob.nz * pn.z
      if (dot > 0.9999) {  // ~40 units
        found = true
        break
      }
    }

    useMountStore.getState().setNearHorse(found)
  })

  return null
}
